import PageHeader from '@components/PageHeader'
import './index.scss'

import { useNavigate } from 'react-router-dom'
import pcoLogo from 'url:@image/pco/registrations-icon.png'
import saltLogo from 'url:@image/salt-icon.png'

import eventsIcon from 'url:@assets/icons/events-icon.svg'

import { useChurchDataProvider } from '@data/ChurchDataProvider'
import { useEffect } from 'react'
import LoadingIndicator from '@components/LoadingIndicator'
import OptionsForm, { OptionsFormCard } from '@components/OptionsForm'

export default function CreateEventPage() {
  const { connectionStatus, reloadConnectionStatus } = useChurchDataProvider();
  const navigate = useNavigate();

  useEffect(() => {
    // Ensure we have the latest connection status when this page mounts
    reloadConnectionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadedConnectionStatus = connectionStatus !== undefined && connectionStatus !== null;
  const isPlanningCenterConnected = connectionStatus?.PLANNING_CENTER == true;

  const planningCenterCard: OptionsFormCard = {
    title: "Import from Planning Center",
    description: "Pick an event from Planning Center to import. Events imported from Planning Center will regularly sync attendees and other data with Salt.",
    logo: {
      image: pcoLogo,
      alt: 'Planning Center'
    },
    enabled: true,
    onClick: () => {
      if (isPlanningCenterConnected) {
        navigate('/events/create/import?provider=PLANNING_CENTER')
      }
    }
  };

  return <div className='create-event-page'>
    <PageHeader title='' showBackButton={true} backLocation="/events" />

    {!loadedConnectionStatus && <LoadingIndicator />}

    {loadedConnectionStatus === true && <OptionsForm
      title="New Event"
      description="Create events that your church members can attend."
      icon={{
        image: eventsIcon,
        alt: 'Events'
      }}
      unavailableText={<>Unavailable creation methods may require you to connect an external provider in <a href='/connections'>Connections</a></>}
      cards={[
        {
          title: "Create in Salt",
          description: "Create a fully custom event, managed in Salt.",
          logo: {
            image: saltLogo,
            alt: 'Salt'
          },
          enabled: true,
          onClick: () => navigate('/events/create/details')
        },
        planningCenterCard
      ]} />}
  </div>
}